export default __webpack_public_path__ + "static/kampaus-miehet-2312144a871d7781223de604edd2e537.jpg";